import { FEEDBACK_RES_ID, NORTHMILL_RES_ID, PRICE_CHECK_RES_ID, PRODUCT_TYPE_RES_ID, PROMO_CARDS_RES_ID, TENANT_RES_ID, USERS_RES_ID, WEBHOOKS_RES_ID } from 'utility/constants';

/** Parent menu resource in `App.tsx` (no `list` route); sider checks this name for the SubMenu. */
const INTEGRATIONS_MENU_RES_ID = 'integrations';
import { getUserRoles, isSupplierOnly } from 'utility/helper';

export const customAccessControlProvider = {
  can: async ({ resource, action, params }: any) => {
    const roles = getUserRoles();

    if (roles.includes("SuperAdmin")) {
      return { can: true };
    }

    // Supplier-only users: no PIM resources (hides all sider menu items).
    if (isSupplierOnly()) {
      return {
        can: false,
        reason: "Unauthorized",
      };
    }

    if (roles.includes("Admin")) {
      if (resource == USERS_RES_ID || resource == TENANT_RES_ID || resource == WEBHOOKS_RES_ID) {
        return {
          can: false,
          reason: "Unauthorized",
        };
      }
    } else if (
      resource == USERS_RES_ID ||
      resource == TENANT_RES_ID ||
      resource == WEBHOOKS_RES_ID ||
      resource == FEEDBACK_RES_ID ||
      resource == PROMO_CARDS_RES_ID ||
      resource == PRICE_CHECK_RES_ID ||
      resource == NORTHMILL_RES_ID ||
      resource == PRODUCT_TYPE_RES_ID ||
      resource == PRODUCT_TYPE_RES_ID.toLowerCase() ||
      resource == INTEGRATIONS_MENU_RES_ID
    ) {
      return {
        can: false,
        reason: "Unauthorized",
      };
    }

    return { can: true };
  },
};
